<template>
  <div class="travelMitoDetail">
    <Header></Header>
    <Nav></Nav>
    <div class="travelDetailsTitle travelMitoDetailTit">
      <div class="travelDetailsTitle_text">
        <h3>美图标题</h3>
        <div>
          <span><img src="../assets/static/images/travelDetailsIcon1.png" alt="">4.930万</span>
          <span><img src="../assets/static/images/travelDetailsIcon2.png" alt="">分享</span>
        </div>
      </div>
      <img src="../assets/static/images/footer-split.png" alt="">
    </div>
    <div class="travelDetails_c">
      <p>过去，有句民间谚语：“食在广州，玩在苏州，穿在杭州，死在柳州”。现在，后三句已经不怎么让人记得了，因为，好
        玩的地方不止是苏州，连地球都嫌小了；穿的衣料，杭州的丝绸也已经不能满足当今人的需求了；死了都火葬了，也不要
        柳州的木材去做棺材了。因此，只有“食在广州”依然被人记得，让人理会，并被不断践行着。</p>
    </div>
    <!--    <div class="travelDetails_message travelDetails_u">
      <h3>上传图片<span>（一次最多上传50张，更多照片可分多次上传）</span></h3>
      <div class="travelDetails_message_right">
        <textarea name="" id=""></textarea>
        <div class="travelDetails_message_button">
          <div class="travelDetails_message_button_left"></div>
          <div class="travelDetails_message_button_right">
            <span class="release">发布</span>
          </div>
        </div>
      </div>
    </div> -->
    <div class="travelDetails_message">
      <h3>留言</h3>
      <div class="travelDetails_message_top">
        <img src="../assets/static/images/travelDetailsIcon3.png" alt="">
        <div class="travelDetails_message_right">
          <div class="textarea">
            <textarea name="" id=""></textarea>
          </div>
          <div class="travelDetails_message_button">
            <div class="travelDetails_message_button_left"></div>
            <div class="travelDetails_message_button_right">
              <span>登录</span>
              <i></i>
              <span>注册</span>
              <span class="release">发布</span>
            </div>
          </div>
        </div>
      </div>
      <div class="travelDetails_message_list">
        <div class="travelDetails_message_tit">最新留言</div>
        <div class="travelDetails_message_list_c">
          <div class="travelDetails_message_item">
            <!-- <img src="../assets/static/img/icon12.jpg" alt=""> -->
            <div>
              <p class="title">Miss_背着背包go</p>
              <p class="text">广州，一个熟悉的地方！照片拍的真好，让人看了也跃跃欲试了，以后我粗去玩也要向你学习多拍照！</p>
              <p class="time">发表于 2019-08-05 14:21</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './common/Header.vue'
  import Nav from './common/Nav.vue'
  import Footer from './common/Footer.vue'
  import Toptitle from './common/Toptitle.vue'
  export default {
    data() {
      return {

      }
    },
    components: {
      Header,
      Footer,
      Nav,
      Toptitle
    },
    computed: {

    },
    mounted() {

    }
  }
</script>

<style>
</style>
